<template>
  <teleport to="body">
    <div v-if="modelValue" class="modal-overlay" @click.self="close">
      <div class="modal" :style="{ width }">
        <header class="modal-header">
          <slot name="header">
            <h2 class="modal-title">{{ title }}</h2>
          </slot>
          <button v-if="showClose" class="close-btn" @click="close" aria-label="Close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </header>
        <section class="modal-body">
          <slot />
        </section>
        <footer class="modal-footer">
          <slot name="footer" />
        </footer>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'PopupModal',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, default: '' },
    width: { type: String, default: '400px' },
    showClose: { type: Boolean, default: true }
  },
  emits: ['update:modelValue'],
  methods: {
    close() {
      this.$emit('update:modelValue', false);
    }
  }
};
</script>

<style scoped>
body {
  overflow: hidden;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.modal-header {
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title {
  font-size: 1.25rem;
  color: #333333;
  margin: 0;
}
.close-btn {
  background: transparent;
  border: none;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
  color: #666666;
}
.close-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
  transform: scale(1.1);
  color: #333333;
}
.modal-body {
  padding: 10px 18px;
  overflow-y: auto;
  flex: 1;
}
.modal-body label {
  font-size: 0.875rem;
  color: #555555;
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 500;
}
.modal-body input {
  width: 100%;
  padding: 10px;
  margin-bottom: 16px;
  font-size: 1rem;
  color: #333333;
  background: #f9f9f9;
  border: 1px solid #cccccc;
  border-radius: 6px;
  overflow: hidden;
}
.modal-body input:focus {
  outline: none;
  border-color: #00274c;
  overflow: hidden;
}
.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  text-align: right;
}
.modal-footer button {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
}
.cancel-btn {
  background: #f0f0f0;
  color: #333333;
  margin-right: 12px;
}
.cancel-btn:hover {
  background: #e0e0e0;
}
.save-btn {
  background: #4f46e5;
  color: #ffffff;
}
.save-btn:hover {
  background: #3832a0;
}

/* ══════════════════════════════════════════════════════════════
   DARK MODE
   ══════════════════════════════════════════════════════════════ */
.theme--dark .modal {
  background: #1a1b23;
  border: 1px solid #2a2c3a;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}
.theme--dark .modal-header {
  border-bottom-color: #2a2c3a;
}
.theme--dark .modal-title {
  color: #e4e5eb;
}
.theme--dark .close-btn {
  color: #8b8d9e;
}
.theme--dark .close-btn:hover {
  background-color: rgba(255, 255, 255, 0.06);
  color: #e4e5eb;
}
.theme--dark .modal-body label {
  color: #8b8d9e;
}
.theme--dark .modal-body input {
  background: #22232e;
  border-color: #2a2c3a;
  color: #d5d6de;
}
.theme--dark .modal-body input:focus {
  border-color: #ffd451;
}
.theme--dark .modal-footer {
  border-top-color: #2a2c3a;
}
.theme--dark .cancel-btn {
  background: #22232e;
  color: #d5d6de;
}
.theme--dark .cancel-btn:hover {
  background: #33354a;
}
</style>
